import { useState } from "react";
import type { RoleRecord, UserSessionView } from "../../shared/models";
import { apiRequest } from "../lib/api";

interface RoleConfirmationPageProps {
  user: UserSessionView;
  roles: RoleRecord[];
  onConfirmed: (user: UserSessionView) => void;
}

export function RoleConfirmationPage({ user, roles, onConfirmed }: RoleConfirmationPageProps) {
  const [role_ids, setRoleIds] = useState<number[]>(user.role_ids);
  const [error, setError] = useState<string | null>(null);
  const activeRoles = roles.filter((role) => role.active === 1);

  async function save(event: React.FormEvent) {
    event.preventDefault();
    setError(null);
    try {
      const response = await apiRequest<{ user: UserSessionView }>("/api/my-roles", {
        method: "PUT",
        body: JSON.stringify({ role_ids }),
      });
      onConfirmed(response.user);
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "Could not save roles");
    }
  }

  return (
    <main className="login-layout">
      <section className="panel login-panel">
        <h1>Confirm Your Roles</h1>
        <p className="muted">Review your assigned production roles before continuing to your schedule.</p>
        <form className="stack" onSubmit={save}>
          <div className="role-checkboxes">
            {activeRoles.map((role) => (
              <label key={role.id} className="checkbox-chip">
                <input
                  type="checkbox"
                  checked={role_ids.includes(role.id)}
                  onChange={(event) => setRoleIds((current) =>
                    event.target.checked
                      ? [...current, role.id]
                      : current.filter((value) => value !== role.id)
                  )}
                />
                <span>{role.name}</span>
              </label>
            ))}
          </div>
          <button type="submit">Save Roles</button>
        </form>
        {error ? <p className="error-banner">{error}</p> : null}
      </section>
    </main>
  );
}
